import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { SquareConfig } from 'services/payment/payment.interface';
import { SquareError } from 'features/payment-form/square-form/square-form.interface';

declare const Square: any;

@Component({
  selector: 'cm-square-form',
  templateUrl: 'square-form.component.html',
  styleUrls: ['square-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SquareFormComponent implements OnInit, OnDestroy {
  @Input() showError = false;
  @Input() paymentConfig: SquareConfig;
  @Output() nonceChange = new EventEmitter<string>();
  @ViewChild('cardContainer') private cardContainer: ElementRef<any>;
  card;
  isFormLoaded = false;
  errorToShow: string;
  errors: SquareError[];

  constructor(private changeDetector: ChangeDetectorRef) {}

  async ngOnInit() {
    try {
      await this.loadForm(Square, this.paymentConfig);
    } catch (e) {
      this.isFormLoaded = true;
      this.errorToShow = 'Square.js failed to load properly';
    }
  }

  ngOnDestroy() {
    if (this.card) {
      this.card.destroy();
    }
  }

  private async loadForm(squareInstance, squareConfig: SquareConfig) {
    const LOCATION_ID = squareConfig.locationId;
    const APPLICATION_ID = squareConfig.applicationId;
    try {
      const payments = squareInstance.payments(APPLICATION_ID, LOCATION_ID);
      this.card = await payments.card();
      this.card.attach(this.cardContainer.nativeElement);
      this.isFormLoaded = true;
      this.changeDetector.detectChanges();
      setTimeout(() => this.card.focus('cardNumber'), 1000);
    } catch (e) {
      this.isFormLoaded = true;
      this.errorToShow = 'ApplicationId and/or locationId is incorrect';
      this.changeDetector.detectChanges();
    }
  }

  async submitForm() {
    this.errorToShow = '';
    this.errors = [];
    try {
      const token = await this.tokenize();
      this.nonceChange.emit(token);
    } catch (e) {
      this.errorToShow = (e as Error).message;
      this.changeDetector.detectChanges();
    }
  }

  private async tokenize() {
    const tokenResult = await this.card.tokenize();
    if (tokenResult.status === 'OK') {
      return tokenResult.token;
    } else {
      const errorMessage = `Tokenization failed with status: ${tokenResult.status}`;
      if (tokenResult.errors) {
        this.errors = tokenResult.errors;
      }
      throw new Error(errorMessage);
    }
  }
}
